<template>
  <div class="fees-list">
    <div class="fees-list__header">
      <Button buttonName="Add" :onClick="handleRedirectCreateFee" classes="primary"/>
    </div>
        <div class="loader" v-if="contents.loading">
          <span aria-hidden="true" class="spinner-border"></span>
      </div>
  <div v-if="contents.fees.length">
    <TableHeader :headers="Object.keys(contents.fees[0])" :widths="state.widths" :ignore="['id']"/>
    </div>
    <div v-if="contents.fees.length">
      <FeeList 
        :widths="state.widths" 
        v-for="fee in contents.fees" 
        :key="fee.id" 
        :contents="fee ? Object.values(fee) : {}"
        :handleRedirect="handleRedirect"
      />
       <div class="table__details" v-if="contents.fees.length">
        <div class="table__details__left">
            <span class="text-muted" v-if="contents.pageInfo.total_pages">Page {{ contents.pageInfo.current_page }} of {{ contents.pageInfo.total_pages }}</span>
        </div>
        <div class="table__details__right">
            <b-pagination-nav :link-gen="linkGen" :number-of-pages="contents.pageInfo.total_pages" use-router align="right" class="justify-content-center justify-content-sm-end m-0" size="sm" />
        </div>
    </div>
    </div>
  </div>
</template>
<script>
import { reactive, onBeforeMount, computed, watch, onMounted } from '@vue/composition-api'
import Table from '@/components/table.vue'
import TableHeader from '@/components/tableheader.vue'
import FeeList from'@/components/feelist.vue'
import Button from '@/components/button.vue';

export default {
  components: {
    Table,
    TableHeader,
    FeeList,
    Button
  },
  setup(props, { root }) {
    const store = root.$store;
    const contents = computed(() => store.getters.getFees);
    const state = reactive({
       widths: ['10%','25%','25%','15%','25%']
    });

    onBeforeMount(() => {
      store.dispatch('getExistingFees', { page: root.$route.params.page ? `${root.$route.params.page}` : '1', merchantId: `${root.$route.params.id}` })
    })

    watch(() => root.$route.query, (val) => {
        store.dispatch('getExistingFees', val)
    })


    const handleRedirect = id => {
      root.$router.push({ name: "merchant-fee-edit", params: { feeId: id } })
    }

    const handleRedirectCreateFee = () => root.$router.push({ name: "merchant-fee-add" })

    function linkGen(pageNum) {
      return '?page=' + pageNum
    }

    return {
      state,
      handleRedirect,
      handleRedirectCreateFee,
      contents,
      linkGen
    }
  }
}
</script>
<style lang="scss">
.fees-list {
  display: flex;
  flex-direction: column;
  margin-bottom: 50px;

  &__header {
    display: flex;
    justify-content: flex-end;
    padding: 25px;

    .btn {
      padding: 10px 30px;
    }
  }
}

</style>